module.exports = __webpack_public_path__ + "img/ht_icon_edit_v2.7ce03f97.svg";